import Thor from '@qconcursos/thor';

const usejQ = typeof fetch !== 'function';

window.Thor = Thor;
window.Thor.setup({ usejQ });

window.Thor.mockRequest = ({
  success = true,
  successResponse = { success: true },
  failResponse = { error: true },
  timeout = 1000
}) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (success) {
        resolve(successResponse);
      } else {
        reject(failResponse);
      }
    }, timeout);
  });
};

export default Thor;
